import React, { Component} from "react";
import axios from 'axios';
import { blueGrey } from '@mui/material/colors';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';
import TableBody from '@mui/material/TableBody'; 
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {DragDropContext,Droppable,Draggable} from '@hello-pangea/dnd';
import SwapVertTwoToneIcon from '@mui/icons-material/SwapVertTwoTone';
import Checkbox from '@mui/material/Checkbox'; 
import FormControlLabel from '@mui/material/FormControlLabel'; 
 export default class  Columnsettings extends Component {

   constructor(props) {
      super(props)
	 
     this.state = { 
	 
	 isselectdisplay:false, cc_id:'',btncoldisable:false,btncoltext:'Save',
	CheckData:[],
	open:false,isdisplay:false,
	
      
  }
  
 
 
   }

handleClickOpen = (e) => {


 
  this.setState({open:!this.state.open,  
	  },()=>{ this.GetCheckBoxData();});
};

 
GetCheckBoxData(){
axios.get(localStorage.getItem("ISIurl")+'ajaxcolumnconfigure.php?action=getall&cc_userid='+localStorage.getItem("ISIuserid")+'&cc_page='+this.props.pageval)
 .then(resp => { 
 if(resp.data.length>0){
	 this.setState({  
			  CheckData: resp.data,isdisplay:false,  
	
		    });
			
			
 }else{
	axios.get(localStorage.getItem("ISIurl")+'ajaxcolumnconfigure.php?action=getall&cc_userid=0&cc_page='+this.props.pageval)
 .then(resp => { 
 if(resp.data.length>0){
	 this.setState({  
			  CheckData: resp.data,isdisplay:false,  
	
		    });		
			
		 }
		 })
 }
});
	
}
 handleClose = () => {
    this.setState(
      { finalValues: this.state.checkboxData, open: false });
  }
 
	
	CheckHandler = (id,rowsd) => {
		
		
	
		
const updatedArray = [...this.state.CheckData];

	if(updatedArray[rowsd].cc_isdisplay==="0")
	{
		updatedArray[rowsd].cc_isdisplay = "1" ;
			  
	}
else{
	updatedArray[rowsd].cc_isdisplay = "0" ;
}
 this.setState({CheckData: updatedArray,},()=>{
	 
	 
	 console.log(this.state.CheckData);
 });


	
  }; 
	 










handleDragEnd = (results)=> {
console.log('resutl',results);
		
			let strcol="",strsep="";
			let i=parseFloat(results.source.index)-1;
			
			let temptaskasgnbyme = [...this.state.CheckData];
			
			const updatedArray = [...this.state.CheckData];
		
			updatedArray[i].cc_sortorder=results.destination.index;
			//console.log('value',updatedArray[i].cc_sortorder);
		this.setState({CheckData: updatedArray,},()=>{
				
				
				console.log(this.state.CheckData);
				
				var rowsArray = this.state.CheckData;  
        
             var newRow = temptaskasgnbyme.map((row, k) => { 
			//alert(k); k start from 0
			let a=parseFloat(k)+1;
			
			const isFound = temptaskasgnbyme.some(element => {
    if (element.cc_sortorder === a) {
     a++;
    }  
  });
			if(results.draggableId!=row.cc_id)
			{
			
				updatedArray[k].cc_sortorder=a;			
			 }
			 
			 
			  strcol=strcol+strsep+row.cc_id+"~"+updatedArray[k].cc_sortorder;
		 strsep=";";
			
			 });
			  var formData = new FormData();
	
		
	formData.append('action','updatesortorder') 
	
		 formData.append('chekedvalues',strcol)
			
	
	
	
	 axios.post(localStorage.getItem("ISIurl")+"ajaxcolumnconfigure.php", formData, {
			}).then(res => {
				 this.GetCheckBoxData();
		})
				
			});
			
			
		
			
		
		

		};

	   handleCheckStatusUpdate = () => {
    const optionsVal = this.state.CheckData;
    let optionValues = "";
    let sep1 = ""; 

    optionsVal.forEach(eachval => {
        optionValues += sep1 + eachval.cc_isdisplay + "~" + eachval.cc_id+ "~" + eachval.cc_columnname;
        sep1 = "`"; 
    });

   var formData = new FormData();
  formData.append('action','UpdateCheckvalue')

  formData.append('chekedvalues',optionValues)         
   formData.append('userid',localStorage.getItem("ISIuserid"))
    formData.append('cc_page',this.props.pageval)
  
         axios.post(localStorage.getItem("ISIurl")+"ajaxcolumnconfigure.php", formData, {
        }).then(res => { this.props.updateDonenew(); this.setState(
      {  open: false });
		})
				
    
};




  render(){
  return (
    <React.Fragment>


	
	
    <div className="checkbox">
  <Dialog
    open={this.state.open}
    onClose={this.handleClose}
    maxWidth="xs"
    fullWidth={true}
  >
    <DialogTitle id="form-dialog-title" className="dialoghead">
   Configure Columns
    </DialogTitle>
    <DialogContent>
	 <div className="configcolumns">
<Paper >
  <TableContainer >  
     <DragDropContext onDragEnd={(results) => this.handleDragEnd(results)}>
       <Table stickyHeader aria-label="sticky table">  
           <TableHead> 
              <TableRow>
                </TableRow></TableHead>				  
			      <Droppable droppableId="TableBody" >
		  
		              {
			          (provided)=>(
			           <TableBody ref={provided.innerRef} {...provided.droppableProps}>
						{(this.state.CheckData).map((item,index) => {
							
							let j=parseFloat(index)+1; 
							let color='';
                          return ( <React.Fragment>
								<TableRow key={j}  >
								 <Draggable draggableId={item.cc_id} index={j} key={item.cc_id}>
										{
								 (provided) => (
								 <TableCell width="15%" align="top"> 
								 <div   {...provided.draggableProps}
								 {...provided.dragHandleProps}  ref={provided.innerRef} >
  
									<SwapVertTwoToneIcon  />

  
								</div>   
								</TableCell> 
									)
								}
							</Draggable>

						<TableCell>
                          {item.cc_isdisplay === "0" && (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  sx={{
                                    color: blueGrey[800],
                                    "&.Mui-checked": {
                                      color: blueGrey[600],
                                    },
                                  }}
                                  
                                  onChange={() => this.CheckHandler(item.cc_id, index)}
                                  inputProps={{ "aria-label": "controlled" }}
                                />
                              }
                              label={item.cc_displayname}
                            />
                          )}
                          {item.cc_isdisplay === "1" && (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  sx={{
                                    color: blueGrey[800],
                                    "&.Mui-checked": {
                                      color: blueGrey[600],
                                    },
                                  }}
								  checked
                                  onChange={() => this.CheckHandler(item.cc_id, index)}
                                  inputProps={{ "aria-label": "controlled" }}
                                />
                              }
                              label={item.cc_displayname}
                            />
                          )}
                        </TableCell>

						</TableRow>
              {provided.placeholder}

				</React.Fragment>	
				);
					})}
				   </TableBody>
          )}
		  </Droppable>	
      </Table>
    </DragDropContext>
    </TableContainer> 

   
  </Paper>

	
	</div>
	
	
	

        <div className="actionbtns">
          <div className="cancelbtn">
            <Button variant="contained" className="frmthirdbtn" onClick={this.handleClickOpen}>
              Cancel
            </Button>
          </div>
          <div className="savebtn">
            <Button variant="contained" disable={this.state.btncoldisable} className="frmSecondarybtn" onClick={this.handleCheckStatusUpdate}>
              {this.state.btncoltext}
            </Button>
          </div>
          <div className="clear"></div>
        </div>
      
    </DialogContent>
  </Dialog>
	</div>
    </React.Fragment>
  )
  
  
  


}
  

}




	
	
	 





 



	
	





